<video-playlist-header [sortInfo]="sortInfo" (onAddNewClick)="showCreatePlaylist = true" (onSortChange)="sortChange()" (onSelectAllPlaylistsChange)="onSelectAllChange($event)">
</video-playlist-header>

<add-playlist *ngIf="showCreatePlaylist" [isSaving]="isCreatingPlaylist" (onSave)="createPlaylist($event)" (onCancel)="showCreatePlaylist = false">
</add-playlist>

<video-playlist *ngIf="playlistCollection.length" [playlistCollection]="playlistCollection" [isPlaylistSaving]="isPlaylistSaving" [sortInfo]="sortInfo" (onCancelPlaylist)="onCancelPlaylist.emit()" (onSavePlaylists)="savePlaylists($event)" (onUpdatePlaylist)="updatePlaylist($event)">
</video-playlist>
